var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn--add-coupon",attrs:{"variant":_vm.variant}},[_c('b-icon-plus',{attrs:{"scale":"1.6"}}),_vm._v("建立優惠券 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }